/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Kpi_Fully_EnrolledInputs */



/**
* | output |
* | --- |
* | "Fully enrolled" |
*
* @param {Partner_Admin_Kpi_Fully_EnrolledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_kpi_fully_enrolled = /** @type {((inputs?: Partner_Admin_Kpi_Fully_EnrolledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Kpi_Fully_EnrolledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vollständig eingerichtet")
	return /** @type {LocalizedString} */ ("Fully enrolled")
});